import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../../i18n/i18n.constants";
import { FormikProps, getIn } from "formik";
import CountrySelector from "../../../../components/countrySelector/CountrySelector";
import { CompanyData } from "../../../../app/models/api/auth/signUpRequest";
import { SelectResponse } from "../../../../app/models/api/selectResponse";
import { useCallback } from "react";
import { isInvalid, isValid } from "../../../../services/form/componentValidation";
import { tinLabelByCountry } from "../../../../app/mappers/companyMappers";

interface Props {
    formik: FormikProps<CompanyData>;
}

const CompanyInputFormElements = ({ formik }: Props) => {
    const { t } = useTranslation(namespaces.auth);

    const companyNameLbl = "companyName";
    const countryLbl = "countryCode";
    const addressLbl = "address";
    const zipLbl = "zip";
    const cityLbl = "city";
    const tinLbl = "tin";

    const handleCountrySelect = useCallback(
        (item: SelectResponse) => {
            formik.setFieldValue(countryLbl, item.value);
        },
        [formik]
    );

    return (
        <>
            <Form.Group className="custom-group-controls mb-3" controlId={companyNameLbl}>
                <Form.Label className="custom-form-label">{t("signUp.companyNameLbl") + "*"}</Form.Label>
                <Form.Control
                    name={companyNameLbl}
                    placeholder={t("signUp.companyNamePlaceholder")}
                    className="custom-form-control"
                    type="text"
                    aria-label={t("signUp.companyNameLbl")}
                    autoFocus
                    value={formik.values.companyName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isValid={isValid(formik, companyNameLbl)}
                    isInvalid={isInvalid(formik, companyNameLbl)}
                />
                <Form.Control.Feedback type="invalid">{formik.errors.companyName}</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="custom-group-controls mb-3" controlId={countryLbl}>
                <CountrySelector
                    label={t("signUp.countryLbl") + "*"}
                    defaultValue={getIn(formik.values, countryLbl) ?? undefined}
                    onSelect={handleCountrySelect}
                />
            </Form.Group>
            <Form.Group className="custom-group-controls mb-3" controlId={addressLbl}>
                <Form.Label className="custom-form-label">{t("signUp.addressLbl") + "*"}</Form.Label>
                <Form.Control
                    name={addressLbl}
                    placeholder={t("signUp.addressPlaceholder")}
                    className="custom-form-control"
                    type="text"
                    aria-label={t("login.addressLbl")}
                    value={formik.values.address}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isValid={isValid(formik, addressLbl)}
                    isInvalid={isInvalid(formik, addressLbl)}
                />
                <Form.Control.Feedback type="invalid">{formik.errors.address}</Form.Control.Feedback>
            </Form.Group>
            <Row>
                <Col md={4} className="pe-md-0">
                    <Form.Group className="custom-group-controls mb-3" controlId={zipLbl}>
                        <Form.Label className="custom-form-label">{t("signUp.zipLbl") + "*"}</Form.Label>
                        <Form.Control
                            name={zipLbl}
                            placeholder={t("signUp.zipPlaceholder")}
                            className="custom-form-control"
                            type="text"
                            aria-label={t("login.zipLbl")}
                            value={formik.values.zip}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isValid={isValid(formik, zipLbl)}
                            isInvalid={isInvalid(formik, zipLbl)}
                        />
                        <Form.Control.Feedback type="invalid">{formik.errors.zip}</Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col md={8}>
                    <Form.Group className="custom-group-controls mb-3" controlId={cityLbl}>
                        <Form.Label className="custom-form-label">{t("signUp.cityLbl") + "*"}</Form.Label>
                        <Form.Control
                            name={cityLbl}
                            placeholder={t("signUp.cityPlaceholder")}
                            className="custom-form-control"
                            type="text"
                            aria-label={t("login.cityLbl")}
                            value={formik.values.city}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isValid={isValid(formik, cityLbl)}
                            isInvalid={isInvalid(formik, cityLbl)}
                        />
                        <Form.Control.Feedback type="invalid">{formik.errors.city}</Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Form.Group className="custom-group-controls mb-3" controlId={tinLbl}>
                <Form.Label className="custom-form-label">{tinLabelByCountry(formik.values.countryCode)}</Form.Label>
                <Form.Control
                    name={tinLbl}
                    placeholder="ХХХХХХХХХХ"
                    className="custom-form-control"
                    type="text"
                    aria-label={t("login.tinLbl")}
                    value={formik.values.tin}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isValid={isValid(formik, tinLbl)}
                    isInvalid={isInvalid(formik, tinLbl)}
                />
                <Form.Control.Feedback type="invalid">{formik.errors.tin}</Form.Control.Feedback>
            </Form.Group>
        </>
    );
};

export default CompanyInputFormElements;
